import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

export const TOPX_TEXTS = {
  TITLE: 'подобрали банки с высокой вероятностью одобрения',
  SUB_TITLE: {
    [PRODUCT_TYPES_VALUES.CREDIT]: 'Эти банки чаще других выдавали кредиты людям с таким же кредитным\u00A0рейтингом',
    [PRODUCT_TYPES_VALUES.CREDIT_CARD]:
      'Эти банки чаще других выдавали кредитные карты людям с таким же кредитным\u00A0рейтингом',
    [PRODUCT_TYPES_VALUES.MICRO_CREDIT]:
      'Эти банки чаще других выдавали кредиты людям с таким же кредитным\u00A0рейтингом',
  },
  ALL_SENT: 'Вы отправили заявки, дождитесь решения от банков',
  ALL_SENT_WL: 'Дождитесь решения от банков',
  SEND_REQUESTS_BUTTON: 'Узнать решение',
};
